module.exports = __webpack_public_path__ + "static/testimonial-2-bbf7a18e2ac2cd07515a63216c4fbbc1.mp4";